import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './PageContentContainer.module.css';

export type PageContentContainerProps = ComponentProps<'div'>;

/**
 * A style component to wrap your content with.
 * Limits the width of the content and centers it.
 */
export const PageContentContainer: FunctionComponent<PageContentContainerProps> =
  React.memo((props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.container)}
      >
        {children}
      </div>
    );
  });
